import React from 'react';
import PropTypes from 'prop-types';
import DocumentClaimsChunk from '@Components/Results/documents/DocumentClaimsChunk';
import ResultDetailCard from '@Components/Results/common/ResultDetailCard';

function DocumentClaims({ closeClick, claimsText }) {
  return (
    <ResultDetailCard
      id="claimsExpanded-content"
      title="Claims"
      className="u-els-margin-top-1o2"
      closeDataE2e="e2e-claims-close"
      onClose={closeClick}>
      <DocumentClaimsChunk chunk={claimsText} />
    </ResultDetailCard>
  );
}

DocumentClaims.propTypes = {
  claimsText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
};

export default DocumentClaims;
